import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { trackPWAInstall } from "../utils/analytics";

// Floating "Install app" button. It only appears when the browser fires the
// `beforeinstallprompt` event (Chrome / Edge / Android) and the app isn't
// already installed. On iOS Safari (which doesn't support the event) it stays
// hidden — users install there via Share -> Add to Home Screen.
const InstallPWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    if (isStandalone) return undefined;

    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    const handleInstalled = () => {
      trackPWAInstall();
      setDeferredPrompt(null);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstall);
    window.addEventListener("appinstalled", handleInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstall);
      window.removeEventListener("appinstalled", handleInstalled);
    };
  }, []);

  if (!deferredPrompt || dismissed) return null;

  const handleInstall = async () => {
    deferredPrompt.prompt();
    try {
      await deferredPrompt.userChoice;
    } catch (e) {
      /* user dismissed */
    }
    setDeferredPrompt(null);
  };

  return (
    <div className="fixed bottom-4 left-4 z-50 flex items-center gap-2 bg-gray-800 border-2 border-cyan-500/40 rounded-2xl shadow-lg pl-3 pr-2 py-2">
      <button
        onClick={handleInstall}
        className="flex items-center gap-2 text-cyan-300 hover:text-cyan-200 font-semibold text-sm"
        title="Install Xunzhine as an app"
      >
        <Download className="w-4 h-4" />
        Install app
      </button>
      <button
        onClick={() => setDismissed(true)}
        className="text-gray-500 hover:text-gray-300 p-1"
        title="Dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default InstallPWA;
